import React from 'react';
import { NextRaceBannerLoadLazy } from '@om-fe/core/core/widgets/omfe-widgets';
import { NextRaceBannerLoadSsr } from '@om-fe/core/core/widgets/omfe-widgets';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { PlatformTypes } from '@om-fe/utils';
import getConfig from '@om-fe/core/utils/config';

type MeetingResultListPageProps = {
  readonly deviceType: PlatformTypes;
  readonly sportId?: string;
  readonly numberOfRaces?: number;
  readonly enabledLoadMore?: boolean;
}

const lang = 'en-GB';

const NextRaceBannerPage = ({
  deviceType,
  sportId,
  numberOfRaces,
  enabledLoadMore,
}: MeetingResultListPageProps) => {
  const isAppLazy: boolean = getConfig().isAppLazy || false;

  if (isAppLazy) {
    return (
      <NextRaceBannerLoadSsr
        lang={lang}
        deviceType={deviceType}
        sportId={sportId}
        numberOfRaces={numberOfRaces}
        enabledLoadMore={enabledLoadMore} />
    );
  }

  return (
      <NextRaceBannerLoadLazy 
        lang={lang} 
        deviceType={deviceType} 
        sportId={sportId}
        numberOfRaces={numberOfRaces}
        enabledLoadMore={enabledLoadMore}
      />
  );
}

export default connect((state: AppState) => {
  return {
    deviceType: state.deviceInfo?.platform.type,
  }
})(NextRaceBannerPage);